import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AbcCoreModule } from '@barthauer/abc/core';
import {
  AbcComponentModule,
  AbcDateBoxComponent,
  AbcDropDownBoxComponent,
  AbcNumberBoxComponent,
  AbcTextBoxComponent,
  AbcTileNavMenuModule,
  AbcUiComponentsModule,
  _AbcGridComponent,
  _AbcSelectBoxComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { ResourceEventMaterialMaterialExpenseComponent } from './resource-event-material-material-expense/resource-event-material-material-expense.component';
import { ResourceEventOtherOtherComponent } from './resource-event-other-other/resource-event-other-other.component';
import { ResourceEventPersonnelWorkingTimesComponent } from './resource-event-personnel-working-times/resource-event-personnel-working-times.component';
import { ResourceEventVehicleDowntimeComponent } from './resource-event-vehicle-downtime/resource-event-vehicle-downtime.component';
import { ResourceEventVehicleMileageComponent } from './resource-event-vehicle-mileage/resource-event-vehicle-mileage.component';
import { ResourceEventVehicleOperatingHoursComponent } from './resource-event-vehicle-operating-hours/resource-event-vehicle-operating-hours.component';
import { ResourceEventVehicleWaterFillingComponent } from './resource-event-vehicle-water-filling/resource-event-vehicle-water-filling.component';
import { ResourceListComponent } from './resource-list/resource-list.component';
import { ResourceListService } from './resource-list/resource-list.service';
import { ResourceNavigationComponent } from './resource-navigation/resource-navigation.component';
import { ResourcesRoutingModule } from './resources-routing.module';
import { ResourcesService } from './resources.service';
import { ResourcesComponent } from './resources/resources.component';

@NgModule({
  declarations: [
    ResourcesComponent,
    ResourceListComponent,
    ResourceNavigationComponent,
    ResourceEventVehicleMileageComponent,
    ResourceEventVehicleOperatingHoursComponent,
    ResourceEventVehicleDowntimeComponent,
    ResourceEventVehicleWaterFillingComponent,
    ResourceEventPersonnelWorkingTimesComponent,
    ResourceEventMaterialMaterialExpenseComponent,
    ResourceEventOtherOtherComponent,
  ],
  providers: [ResourcesService, ResourceListService],
  imports: [
    CommonModule,
    ResourcesRoutingModule,
    MatToolbarModule,
    MatChipsModule,
    MatCardModule,
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    AbcCoreModule,
    AbcTileNavMenuModule,
    AbcDateBoxComponent,
    AbcComponentModule,
    AbcUiComponentsModule,
    _AbcTextAreaComponent,
    AbcTextBoxComponent,
    // _AbcCardComponent,  //-> At the moment an 1-to-1-derivat of mat-card
    AbcNumberBoxComponent,
    _AbcSelectBoxComponent,
    _AbcTextAreaComponent,
    AbcDropDownBoxComponent,
    _AbcGridComponent,
  ],
})
export class ResourcesModule {}
